import { Component, Input } from '@angular/core';
import { RouteCardItemDto } from '@shared/src/dtos/route/RouteCardItemDto';

@Component({
  selector: 'shared-trucking-route-strip-card-component',
  templateUrl: './shared.trucking.route.strip.component.html',
  styleUrls: ['./shared.trucking.route.strip.component.scss'],
})
export class SharedTruckingRouteStripComponent {

  public useIonic: boolean = false;

  constructor() {
  
  }

  public showAssignedSlots: boolean = false;

  private _route: RouteCardItemDto;
  @Input()
  set route(value: RouteCardItemDto) {
    if (this._route === value)
      return;
    this._route = value;
    this.obtainValues();
  }
  get route(): RouteCardItemDto {
    return this._route;
  }
  private obtainValues() {
  }


  OnInit() {
  }

  public pretty(value) {
    return JSON.stringify(value);
  }
}
